import { defineComponent, ref, computed, watch, createElementBlock, openBlock, unref, normalizeClass, createBlock, createCommentVNode, renderSlot, createVNode } from "vue";
import { loaderAnimationData } from "../../assets/lottie/loader.js";
import { _sfc_main as _sfc_main$1 } from "../WBadge/WBadge/index.js";
import "../WIcon/WIconStd/index.js";
import { WLottie } from "../WLottie/index.js";
import { _export_sfc } from "../WAccordion/index.js";
import "../WIcon/WIconExt/index.js";
import './index.css';const DATA_TEST = {
  WRAPPER: "w-toggle-button-wrapper",
  ELM: "w-toggle-button",
  ICON: "w-toggle-button-icon",
  LOADER: "w-toggle-button-loader"
};
const _hoisted_1 = ["aria-pressed", "aria-disabled", "disabled", "data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WToggleButton",
  props: {
    activeIcon: {},
    inactiveIcon: {},
    modelValue: { type: Boolean, default: void 0 },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "toggle"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const localActive = ref(props.modelValue ?? false);
    const isActive = computed({
      get: () => props.modelValue ?? localActive.value ?? false,
      set: (value) => {
        localActive.value = value;
      }
    });
    const iconName = computed(
      () => isActive.value ? props.activeIcon : props.inactiveIcon
    );
    watch(
      () => props.modelValue,
      (value) => {
        isActive.value = value ?? false;
      },
      { immediate: true }
    );
    function toggleHandler() {
      const newValue = !isActive.value;
      isActive.value = newValue;
      emit("update:modelValue", newValue);
      emit("toggle", newValue);
    }
    const classes = computed(() => [
      {
        "--active": isActive.value,
        "--disabled": props.disabled,
        "--loading": props.loading
      }
    ]);
    const ariaPressed = computed(() => isActive.value ? "true" : "false");
    const ariaDisabled = computed(
      () => props.disabled || props.loading ? "true" : "false"
    );
    const disabledComputed = computed(
      () => props.disabled || props.loading || void 0
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass(["w-toggle-button", classes.value]),
        "aria-pressed": ariaPressed.value,
        "aria-disabled": ariaDisabled.value,
        disabled: disabledComputed.value,
        "data-t": unref(DATA_TEST).ELM,
        onClick: toggleHandler
      }, [
        _ctx.loading ? (openBlock(), createBlock(unref(WLottie), {
          key: 0,
          "animation-data": unref(loaderAnimationData),
          loop: "",
          "is-current-color": "",
          class: "w-toggle-button__loader",
          "data-t": unref(DATA_TEST).LOADER
        }, null, 8, ["animation-data", "data-t"])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {}, () => [
          createVNode(unref(_sfc_main$1), {
            class: "w-toggle-button__icon",
            name: iconName.value,
            "data-t": unref(DATA_TEST).ICON
          }, null, 8, ["name", "data-t"])
        ], true)
      ], 10, _hoisted_1);
    };
  }
});
const WToggleButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-96bac380"]]);
export {
  WToggleButton
};
